import React, { useEffect, useState } from 'react';
import InfiniteScroll from "react-infinite-scroller";
import { ReactSession } from 'react-client-session';
import { Link } from 'react-router-dom';
import axios from "axios";
import { Markup } from 'interweave';
import {Helmet} from "react-helmet";

import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import Footer from "../../Footer/Footer";
import Spinner from '../../Global/Spinner';
import EmptyContent from '../../Global/EmptyContent';

import '../Dashboard.css';
import classes from "./Notifications.module.css";
import styles from '../Dashboard.module.css';

import noThumb from "../../../images/no-thumb.jpg";


function Notifications() {
    const [notifs, setNotifs] = useState([]);
    const [count, setCount] = useState(0);
    const [hasMore, sethasMore] = useState(true);
    const [page, setpage] = useState(2);
    const [loading, setLoading] = useState(false);
    ReactSession.setStoreType("localStorage");

    const logged_user = ReactSession.get("logged_user");
    
    useEffect(() => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/notifsCount.php`, {
            user_id: logged_user
        }, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        })
          .then(res => {
            res.data.status === 'success' && setCount(res.data.count);
          }).catch(err => {
              console.log(err);
          })
    }, [])

    const config = {
        params: {
            uid: logged_user,
            action: 'updateNotifs',
            limit: 10
        },
        headers: {
            "Content-Type": "multipart/form-data",
        }
    }

    useEffect(() => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/notifs.php`, null, config)
          .then(res => {
              setNotifs(res.data);
              res.data.length < config.params.limit ? sethasMore(false) : sethasMore(true);

              setLoading(true);
          }).catch(err => {
              console.log(err);
          })
    }, [])
      
    const loadMore = () => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/notifs.php?page=${page}`, null, config)
        .then(res => {
            if(res.data.message !== 'No notifications found') {
                loading && hasMore && setNotifs([...notifs, ...res.data]);
                setpage(page + 1);

                res.data.length < config.params.limit ? sethasMore(false) : sethasMore(true);
            }
        }).catch(err => {
            console.log(err);
        });
    }

    const readNotif = (id) => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/notifReadAll.php`, {
          id: id,
          action: 'READ_ONE'
        }, {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        }).then(res => {
          // console.log(res.data);
        })
    }

    const readAll = () => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/notifReadAll.php`, {
            user_id: logged_user,
            action: 'READ_ALL'
        }, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        })
        .then(res => {
            if(res.data.status === 'success') {
                document.querySelectorAll(`.${classes.notif_unread}`).forEach(e => e.setAttribute('style', 'background-color: white !important'));
            }

            console.log(res.data);
        })
    }

  return (
    <>
        <Helmet>
            <title>Notifications</title>
        </Helmet>
        <div className="container_wrapper">
            <Header />
            <div className={`${styles.main} main`}>
                <Sidebar active="notifications" />
                <div className={styles.main_content}>
                    <div className={styles.content_body}>
                        <div className={`${styles.title} mb-4`}>
                            <h5><i className="fa-regular fa-bell"></i> Notifications</h5>
                        </div>
                        <div className={`${styles.card} mb-5`}>
                            <div className="card-body">
                                {
                                    count > 0 ? <>
                                        <div className={`${classes.top} pb-3`}>
                                            <div className={classes.act_count}>
                                                <div className={`badge ${classes.bg_info}`}><i className="fa-solid fa-bell"></i> {count}</div>
                                            </div>
                                            <Link to={false} onClick={() => readAll()}>Mark all as read</Link>
                                        </div>
                                            {
                                                notifs && notifs.map &&  <InfiniteScroll
                                                    pageStart={0}
                                                    loadMore={loadMore}
                                                    hasMore={hasMore}
                                                    loader={<div className="loader my-4" key={0} align="center">{<Spinner />}</div>}
                                                    className=''
                                                >
                                                    {
                                                        notifs.map((notif, index) => {
                                                            return (
                                                                notif.name && notif.msg && notif.url && <div className={`${classes.notif} ${notif.status === '0' ? classes.notif_unread : ''}`} key={index}>
                                                                    <div>
                                                                        <div className={classes.userProfile}>
                                                                            <Link to={`/profile/${notif.user_id}/${notif.nice_url}`}>
                                                                                <img src={notif.avatar} onError={e => {e.target.src = noThumb}} alt={notif.name} />
                                                                            </Link>
                                                                        </div>
                                                                        <div className={classes.notifMsg}>
                                                                            <Link className={classes.notifItem} to={`/profile/${notif.user_id}/${notif.nice_url}`}>
                                                                                <b><Markup content={notif.name} /></b>
                                                                            </Link>
                                                                            <Link onClick={() => readNotif(notif.id)} to={notif.url}>
                                                                                <span className="text-muted"><Markup content={notif.msg} /></span>
                                                                            </Link>
                                                                        </div>
                                                                    </div>
                                                                    <div className={classes.time}>{notif.time_ago}</div> 
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </InfiniteScroll>
                                            }
                                        </>
                                    : <EmptyContent />
                                    }
                            </div>
                        </div>
                    </div>
                <Footer />
                </div>
            </div>
        </div>
    </>
  );
}

export default Notifications;